import { useCompanySettings } from './useCompanySettings';

/**
 * Single source of truth for the active company's IANA timezone string.
 * Falls back to "UTC" while settings are loading or if the column is null.
 *
 * Reads from `company_settings.timezone` via the existing `useCompanySettings`
 * hook, which already fetches the full settings row through the
 * `get_company_settings` RPC.
 */
export const useCompanyTimezone = (): string => {
  const { settings } = useCompanySettings();
  // `settings` is typed as the scheduling subset, but the underlying RPC
  // returns the full row including `timezone` — read it defensively.
  const tz = (settings as unknown as { timezone?: string | null } | undefined)?.timezone;
  return tz && tz.trim() ? tz : 'UTC';
};
